<template>
  <v-dialog
    :model-value="showSectionInfo"
    @update:model-value="$emit('update:showSectionInfo', $event)"
    persistent
    max-width="950px"
    content-class="section-info-preview-dialog"
  >
    <v-card
      v-if="previewSectionInfoMeta"
      class="pa-16"
      :color="isDark ? '#2d2d2d' : 'rgba(255,255,255,1)'"
    >
      <v-card-actions class="pa-0">
        <v-flex class="text-right">
          <v-btn
            icon
            variant="text"
            class="position-absolute"
            style="top: 30px; right: 30px"
            @click="closePopup"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-card-actions>
      <div class="featured-image-container" :class="{ noimage: !imageSrc }">
        <img
          :src="imageSrc"
          class="rounded-0 justify-center align-center featured-image"
        />

        <div class="featured-image-content-container">
          <v-card-title
            style="word-break: break-word"
            :class="{ caption: xs, 'text-h3': smAndUp }"
            class="text-uppercase font-weight-bold text-white pb-0 px-10 text-center justify-center align-center text-wrap custom-line-height"
          >
            {{ previewSectionInfoMeta.title }}
          </v-card-title>
          <v-card-text
            v-if="previewSectionInfoMeta.authorName"
            class="pt-3 pb-1 text-white font-weight-bold text-center align-center justify-center"
          >
            Author: {{ previewSectionInfoMeta.authorName }}
          </v-card-text>
          <v-card-text
            class="pa-0 text-white font-weight-bold text-center align-center justify-center"
          >
            Length: {{ previewSectionInfoMeta.units.length }} weeks
          </v-card-text>
        </div>
      </div>
      <v-container class="py-12">
        <v-row>
          <v-col cols="12" lg="5" class="_pa-0">
            <v-card flat tile>
              <v-card-title class="pl-0 col-headers">UNITS</v-card-title>
              <ul class="units-list">
                <li v-for="(u, i) in previewSectionInfoMeta.units" :key="i">
                  {{ getUnitTitle(u) }}
                </li>
              </ul>
            </v-card>
          </v-col>
          <v-col cols="12" lg="7" class="_pa-0">
            <v-card flat tile v-if="previewSectionInfoMeta.sectionOverview">
              <v-card-title class="pl-0 col-headers">OVERVIEW</v-card-title>
              <div v-html="previewSectionInfoMeta.sectionOverview"></div>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="py-9">
          <v-divider class="solid"></v-divider>
        </v-row>
        <v-row>
          <v-col
            v-if="previewSectionInfoMeta.uploadedAuthorImageURL"
            cols="12"
            lg="3"
            class="_pa-0"
          >
            <img
              :src="previewSectionInfoMeta.uploadedAuthorImageURL"
              alt="avatar"
              class="author-avatar rounded-circle"
            />
          </v-col>
          <v-col cols="12" lg="9" class="_pa-0">
            <div
              v-if="previewSectionInfoMeta.authorName"
              class="font-weight-bold"
            >
              {{ previewSectionInfoMeta.authorName }}
            </div>
            <div
              v-if="previewSectionInfoMeta.authorBio"
              v-html="previewSectionInfoMeta.authorBio"
            ></div>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
  import { useDisplay, useTheme } from 'vuetify'
  import { computed } from 'vue'
  export default {
    name: 'PreviewPopup',
    props: ['previewSectionInfoMeta', 'showSectionInfo'],
    setup(props) {
      const display = useDisplay() // xs, sm, md, lg, xl... plus helpers like smAndUp
      const theme = useTheme()
      const isDark = computed(() => theme.global.current.value.dark)
      const getUnitTitle = (unit) => {
        if (!unit) return ''
        const lang = props.previewSectionInfoMeta?.requiredLanguage || 'en'
        const lcTitle = unit.localizedContent?.[lang]?.title
        if (lcTitle && lcTitle.trim()) return lcTitle
        return unit.title || ''
      }

      // expose just what you use in the template
      return {
        xs: display.xs,
        smAndUp: display.smAndUp,
        isDark,
        getUnitTitle,
      }
    },
    computed: {
      imageSrc() {
        return this.previewSectionInfoMeta?.uploadedFeatureImageURL || ''
      },
    },
    methods: {
      closePopup() {
        this.$emit('update:showSectionInfo', false) // This will update the v-model in the parent
        this.$emit('listevent', true) // Optional: if you're using this for additional handling
      },
    },
  }
</script>

<style>
  .section-info-preview-dialog .col-headers {
    color: #a5d867;
    font-weight: 700;
  }
  .section-info-preview-dialog .units-list {
    list-style: none;
    padding: 0;
  }
  .section-info-preview-dialog .units-list li {
    margin-bottom: 10px;
  }
  .section-info-preview-dialog ol,
  .section-info-preview-dialog ul {
    padding-left: 1.5em;
  }
  .section-info-preview-dialog ol li,
  .section-info-preview-dialog ul li {
    margin-bottom: 8px;
  }
  .section-info-preview-dialog .author-avatar {
    width: 100%;
    max-width: 156px;
  }
  .section-info-preview-dialog .featured-image-container {
    position: relative;
    line-height: 0;
  }
  .section-info-preview-dialog .featured-image-container:before {
    content: '';
    background: rgb(0 0 0 / 33%);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .section-info-preview-dialog .featured-image-container.noimage {
    display: flex;
    flex-direction: column;
    padding-bottom: 52.25%;
    background: grey;
  }
  .section-info-preview-dialog .featured-image {
    /* display: flex;
    flex-direction: column; */
    /* min-height: 500px; */
    /* padding-bottom: 52.25%; */
    width: 100%;
  }
  .section-info-preview-dialog .featured-image-content-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
  }
  .v-card .v-card-title.custom-line-height {
    line-height: 1.2; /* tweak until it matches Vuetify 2's display-2 */
  }
</style>
